export default "__VITE_ASSET__BGWcsSmg__"